module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module chunks = 2